<template>
  <el-dialog
      v-if="dialogVisible"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="快递信息"
      width="1000px">
    <el-form ref="form" :model="form">
      <el-row>
        <el-col :span="6">
          <el-form-item label="快递类型">{{form.expName}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="快递单号">{{form.number}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="快递状态">
            <span v-if="form.deliveryStatus === '0'">揽件</span>
            <span v-if="form.deliveryStatus === '1'">在途中</span>
            <span v-if="form.deliveryStatus === '2'">正在派件</span>
            <span v-if="form.deliveryStatus === '3'">已签收</span>
            <span v-if="form.deliveryStatus === '4'">派送失败</span>
            <span v-if="form.deliveryStatus === '5'">疑难件</span>
            <span v-if="form.deliveryStatus === '6'">退件签收</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="更新时间">{{form.updateTime}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="快递用时">{{form.takeTime}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
        ref="vmTable"
        module="basic"
        border
        :data="form.list">
      <el-table-column prop="time" label="时间" align="left" width="150"/>
      <el-table-column prop="status" label="状态" align="left"/>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name: "PurchaseOrderAttachment",
    components: {},
    data() {
      return {
        dialogVisible: false,
        form: {
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.$http
          .get("basic", `deliveryLogisticsRecordses/selectByNo/${row.pkId}`)
          .then((resp) => {
            this.form = resp;
          }).catch(() => {
            this.$message.error("快递信息获取失败");
          });
      },

      openByBillId(row) {
        this.dialogVisible = true;
        this.$http
          .get("basic", `deliveryLogisticsRecordses/getOrderInfo/${row.pkId}`)
          .then((resp) => {
           let result = JSON.stringify(resp.data.logisticsLog);
           this.form=result.esWaybill;
          }).catch(() => {
            this.$message.error("快递信息获取失败");
          });
      },
    },
  };
</script>

<style scoped>

</style>